import axios from 'axios';

export default {
    state: {
        clientInfo: {},
    },
    mutations: {
        setClient: (state, item) => state.clientInfo = item,
    },
    actions: {
        async login(ctx, data){
            let host = `https://${window.authSub}.${window.rsvDomain}/login/submit`;
            try {
                let resp = await axios.post(host, data);
                if(resp.status == 200){
                    let jwt = resp.data.Data.jwt;
                    localStorage.setItem('rsv_token',jwt);
                    return 200;
                }
            } catch (e) {
                return e.response.status;
            }
        },
        async register(ctx, data){
            console.log('reg user');
            let host = `https://${window.authSub}.${window.rsvDomain}/registration/submit`;
            try {
                let resp = await axios.post(host, data);
                return resp;
            } catch (e) {
                return e.response.status;
            }
        },
        validateEmail(ctx, email){
            const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        },
        getClient(ctx, id){
            //go to auth api for redirect and docs urls.
            let client =  {
                redirect_uri: 'http://localhost:8081',
                user_agreemen_file: 'google.com',
                confidentiality_politics_file: 'google.com',
            };
            console.log(client);

            ctx.commit('setClient', client);
        },
    },
    getters: {
        client: state => state.clientInfo,
    },
};
